<template>
  <div class="container-fluid print-launch-releases">
    <ErrorsMessages :errors="errors" />
    <b-overlay :show="loading" opacity="0.99">
      <div class="text-right mb-2 btn-print-launch-releases">
        <v-btn class="btn-print" @click="handlePrint"
          ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
        >
      </div>
      <table class="bg-white">
        <thead>
          <tr>
            <td>
              <div class="header-space">
                <div style="page-break-after: always !important">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div class="d-flex align-items-center">
                      <div>
                        <img
                          style="
                            height: 80px !important;
                            object-fit: cover !important;
                          "
                          v-if="rest_home_logo_url"
                          class="rest_home_logo_url"
                          :src="rest_home_logo_url"
                        />
                        <div v-if="!rest_home_logo_url" class="ml-1">
                          <strong class="text-uppercase">{{
                            rest_home_name
                          }}</strong>
                        </div>
                      </div>
                      <div class="ml-5">
                        <b style="font-size: 28px !important">
                          {{ rest_home_fantasy_name }}
                        </b>
                        <div>
                          <p class="m-0">
                            Regime de
                            {{
                              cash_competence == "cash"
                                ? "Caixa"
                                : "Competência"
                            }}
                          </p>
                          <ListFilters
                            :types_of_entries_ids="types_of_entries_ids"
                            :users_ids="users_ids"
                            :provider_ids="provider_ids"
                            :finance_client_ids="finance_client_ids"
                            :finance_configuration_document_types_ids="
                              finance_configuration_document_types_ids
                            "
                            :finance_configuration_payment_methods_ids="
                              finance_configuration_payment_methods_ids
                            "
                            :finance_configuration_category_ids="
                              finance_configuration_category_ids
                            "
                            :finance_configuration_profit_cost_center_ids="
                              finance_configuration_profit_cost_center_ids
                            "
                            :finance_configuration_tag_ids="
                              finance_configuration_tag_ids
                            "
                            :cost_types_ids="cost_types_ids"
                            :cost_appropriations_ids="cost_appropriations_ids"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="d-flex">
                      <img
                        width="150px"
                        height="50px"
                        :src="require('../../../../assets/logo.png')"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="content">
                <div v-show="data.length > 0">
                  <v-data-table
                    class="v-data-table-no-border"
                    :headers="headers"
                    :items="data"
                    item-key="id"
                    :footer-props="{
                      'items-per-page-options': [25],
                      'items-per-page-text': 'Mostrar',
                    }"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:[`item.categories`]="{ item }">
                      <small v-if="item.type == 'TRANSFERENCIA'">
                        Transferência
                      </small>
                      <small
                        v-if="
                          item.type == 'CONTAS_A_PAGAR' ||
                          item.type == 'CONTAS_A_RECEBER'
                        "
                      >
                        {{ item.finance_configuration_category_name }}
                      </small>
                    </template>
                    <template v-slot:[`item.description`]="{ item }">
                      <div v-if="item.type == 'TRANSFERENCIA'">
                        {{ item.finance_configuration_account_name }}
                        <hr class="m-0" />
                      </div>
                      <div
                        class="row"
                        v-if="
                          item.type == 'previous_balance' ||
                          item.type == 'opening_balance'
                        "
                      >
                        <div
                          :class="[
                            'd-flex align-items-center',
                            item.type == 'previous_balance' && 'col-md-12',
                            item.type == 'opening_balance' && 'col-md-3',
                          ]"
                        >
                          {{ item.description }}
                        </div>
                        <div
                          :class="[
                            item.type == 'previous_balance' &&
                              'col-md-12 pt-0 pb-0',
                            item.type == 'opening_balance' && 'col-md-9',
                          ]"
                        >
                          <p
                            class="m-0 worksansr"
                            v-for="(account, account_key) in item.accounts"
                            :key="`${account.account_nickname}-${account_key}`"
                          >
                            {{ account.account_nickname }} -
                            {{ formatMoney(String(account.balance_date)) }}
                          </p>
                        </div>
                      </div>
                      <div
                        v-if="
                          item.type != 'previous_balance' &&
                          item.type != 'opening_balance'
                        "
                      >
                        {{ item.description }}
                      </div>
                    </template>
                    <template v-slot:[`item.profit_cost_center`]="{ item }">
                      {{
                        item.finance_configuration_profit_cost_center_description
                      }}
                    </template>
                    <template v-slot:[`item.client_provider`]="{ item }">
                      {{
                        item.spent_or_gain == "DEBITO"
                          ? item.provider_company_name
                          : item.finance_client_name
                      }}
                    </template>
                    <template v-slot:[`item.value`]="{ item }">
                      <span
                        v-if="
                          item.type != 'previous_balance' &&
                          item.type != 'opening_balance'
                        "
                      >
                        {{ item.color == "danger" ? "-" : "" }}
                        {{ formatMoney(String(item.value).replace("-", "")) }}
                      </span>
                      <span
                        v-if="
                          item.type == 'previous_balance' ||
                          item.type == 'opening_balance'
                        "
                      >
                        {{ formatMoney(String(item.value)) }}
                      </span>
                      <span
                        class="pl-1 pr-1"
                        v-if="item.is_repeat == 'MAIS_DE_UMA_VEZ'"
                      >
                        {{ item.index_key }}/{{ item.how_many_times }}
                      </span>
                      <span
                        class="pl-1 pr-1"
                        v-if="item.is_repeat == 'MAIS_DE_UMA_VEZ'"
                      >
                        {{ item.periodicity }}
                      </span>
                    </template>
                    <template v-slot:[`item.balance`]="{ item }">
                      <span>{{ formatMoney(String(item.balance)) }}</span>
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                      <div v-if="item.type == 'TRANSFERENCIA'">
                        Transferido <i class="fas fa-random"></i>
                      </div>
                      <div
                        v-if="
                          item.type == 'CONTAS_A_PAGAR' ||
                          item.type == 'CONTAS_A_RECEBER'
                        "
                      >
                        <span small v-if="item.is_paid == 0">
                          <i class="fas fa-clock mr-1"></i
                          >{{
                            item.type == "CONTAS_A_PAGAR" ? "Pagar" : "Receber"
                          }}
                        </span>
                        <span small disabled v-if="item.is_paid == 1">
                          <i class="fas fa-check mr-1"></i
                          >{{
                            item.type == "CONTAS_A_PAGAR" ? "Pago" : "Recebido"
                          }}
                        </span>
                      </div>
                    </template>
                  </v-data-table>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="!exist_data" class="p-2 text-center v-yellow">
        Não existem lançamentos para esta filtragem.
      </div>
      <hr />
      <div class="row bg-white page-break-inside-avoid">
        <div
          class="col-md-2 pt-0 pb-0 d-flex align-items-center justify-content-center"
        >
          Resumo do período
        </div>
        <div class="col-md-10 pt-0 pb-0">
          <div class="row">
            <div class="col-md-12 pt-0 pb-0">
              <div class="row d-flex align-items-center">
                <div class="col-md-3 pt-0 pb-0">
                  <p class="m-0 worksansr">Total de ganhos</p>
                </div>
                <div class="col-md-7 pt-0 pb-0"></div>
                <div class="col-md-2 pt-0 pb-0">
                  <p :class="['m-0']">
                    {{
                      parseFloat(total_gain) >= 0
                        ? formatMoney(String(total_gain))
                        : `${formatMoney(String(total_gain))}`
                    }}
                  </p>
                </div>
              </div>
              <hr class="m-0" />
            </div>
            <div class="col-md-12 pt-0 pb-0">
              <div class="row d-flex align-items-center">
                <div class="col-md-3 pt-0 pb-0">
                  <p class="m-0 worksansr">Total de gastos</p>
                </div>
                <div class="col-md-7 pt-0 pb-0"></div>
                <div class="col-md-2 pt-0 pb-0">
                  <p class="m-0">
                    {{ formatMoney(String(total_spent)) }}
                  </p>
                </div>
              </div>
              <hr class="m-0" />
            </div>
            <div class="col-md-12 pt-0 pb-0">
              <div class="row d-flex align-items-center">
                <div class="col-md-3 pt-0 pb-0">
                  <p class="m-0 worksansr">Resultado do período</p>
                </div>
                <div class="col-md-7 pt-0 pb-0"></div>
                <div class="col-md-2 pt-0 pb-0">
                  <p :class="['m-0']">
                    {{ formatMoney(String(period_result)) }}
                  </p>
                </div>
              </div>
              <hr class="m-0" />
            </div>
            <div class="col-md-12 pt-0 pb-0">
              <div class="row d-flex align-items-center">
                <div class="col-md-3 pt-0 pb-0">
                  <p
                    class="m-0 worksansr"
                    v-if="dayMonthYear == 'day' && !filter_by_period"
                  >
                    Saldo previsto em {{ moment(month).format("LL") }}
                  </p>
                  <p
                    class="m-0 worksansr"
                    v-if="dayMonthYear == 'month' && !filter_by_period"
                  >
                    Saldo previsto em
                    {{ moment(month).endOf("month").format("LL") }}
                  </p>
                  <p
                    class="m-0 worksansr"
                    v-if="dayMonthYear == 'year' && !filter_by_period"
                  >
                    Saldo previsto em
                    {{ moment(month).endOf("year").format("LL") }}
                  </p>
                  <p class="m-0 worksansr" v-if="filter_by_period">
                    Saldo previsto em
                    {{ moment(end_date).format("LL") }}
                  </p>
                </div>
                <div class="col-md-7 pt-0 pb-0"></div>
                <div class="col-md-2 pt-0 pb-0">
                  <p :class="['m-0']">
                    {{ formatMoney(String(period_result)) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 pt-0 pb-0 text-center">
          <hr class="m-0" />
          (Assinatura eletrônica)
          {{
            professionalClassCouncilValue({
              id: user.professional_class_council_id,
              name: user.name,
              profile: user.profile_name,
              cpf: user.cpf,
              office: user.office,
              value: user.professional_class_council_value,
            })
          }}
          <small> - {{ moment().format("DD/MM/YYYY HH:mm:ss") }} </small>
        </div>
      </div>
      <div
        v-show="data.length > 0"
        class="text-right mt-2 btn-print-launch-releases"
      >
        <v-btn class="btn-print" @click="handlePrint"
          ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
        >
      </div>
    </b-overlay>
  </div>
</template>

<script>
import api from "../../../../services/api";

import ErrorsMessages from "../../../Components/ErrorsMessages";

import ListFilters from "../List/ListFilters";

import routes from "../../../../routes";

import {
  formatMoney,
  professionalClassCouncilValue,
} from "../../../../lib/format";

import { userData } from "../../../../lib/functions";

import moment from "moment";

export default {
  name: "PrintLaunchReleases",
  components: {
    ErrorsMessages,
    ListFilters,
  },
  data() {
    return {
      user: {},
      headers: [
        { text: "", value: "data-table-expand", sortable: false },
        { text: "Data", value: "date", sortable: false },
        { text: "Categoria", value: "categories", sortable: false },
        { text: "Descrição", value: "description", sortable: false },
        { text: "C.Custo/Lucro", value: "profit_cost_center", sortable: false },
        {
          text: "Cliente/Fornecedor",
          value: "client_provider",
          sortable: false,
        },
        { text: "Valor", value: "value", sortable: false },
        { text: "Saldo", value: "balance", sortable: false },
        { text: "Status", value: "status", sortable: false },
      ],
      start_date: moment().format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
      filter_by_period: false,
      type: "TODOS",
      cash_competence: "cash",
      month: moment().format("YYYY-MM-DD"),
      dayMonthYear: "month",
      account_ids: [],
      types_of_entries_ids: [],
      users_ids: [],
      provider_ids: [],
      finance_client_ids: [],
      finance_configuration_document_types_ids: [],
      finance_configuration_payment_methods_ids: [],
      finance_configuration_category_ids: [],
      finance_configuration_profit_cost_center_ids: [],
      finance_configuration_tag_ids: [],
      cost_types_ids: [],
      cost_appropriations_ids: [],
      exist_data: false,
      data: [],
      balance_date: 0,
      total_gain: 0,
      total_spent: 0,
      period_result: 0,
      rest_home_name: "",
      client: {},
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    moment,
    formatMoney,
    professionalClassCouncilValue,
    async retrieve() {
      let {
        type,
        cash_competence,
        month,
        dayMonthYear,
        account_ids,
        types_of_entries_ids,
        users_ids,
        provider_ids,
        finance_client_ids,
        finance_configuration_document_types_ids,
        finance_configuration_payment_methods_ids,
        finance_configuration_category_ids,
        finance_configuration_profit_cost_center_ids,
        finance_configuration_tag_ids,
        cost_types_ids,
        cost_appropriations_ids,
        filter_by_period,
        start_date,
        end_date,
      } = routes.currentRoute.params;

      if (
        !type ||
        !cash_competence ||
        !month ||
        !dayMonthYear ||
        !account_ids ||
        !types_of_entries_ids ||
        !users_ids ||
        !provider_ids ||
        !finance_client_ids ||
        !finance_configuration_document_types_ids ||
        !finance_configuration_payment_methods_ids ||
        !finance_configuration_category_ids ||
        !finance_configuration_profit_cost_center_ids ||
        !finance_configuration_tag_ids ||
        !cost_types_ids ||
        !cost_appropriations_ids ||
        !filter_by_period ||
        !start_date ||
        !end_date
      ) {
        routes.push({ name: "dashboard" });
        return;
      }

      this.type = type;
      this.cash_competence = cash_competence;
      this.month = month;
      this.dayMonthYear = dayMonthYear;
      this.account_ids = account_ids.split(",");
      this.types_of_entries_ids =
        types_of_entries_ids != "false" ? types_of_entries_ids.split(",") : [];
      this.users_ids = users_ids != "false" ? users_ids.split(",") : [];
      this.provider_ids =
        provider_ids != "false" ? provider_ids.split(",") : [];
      this.finance_client_ids =
        finance_client_ids != "false" ? finance_client_ids.split(",") : [];
      this.finance_configuration_document_types_ids =
        finance_configuration_document_types_ids != "false"
          ? finance_configuration_document_types_ids.split(",")
          : [];
      this.finance_configuration_payment_methods_ids =
        finance_configuration_payment_methods_ids != "false"
          ? finance_configuration_payment_methods_ids.split(",")
          : [];
      this.finance_configuration_category_ids =
        finance_configuration_category_ids != "false"
          ? finance_configuration_category_ids.split(",")
          : [];
      this.finance_configuration_profit_cost_center_ids =
        finance_configuration_profit_cost_center_ids != "false"
          ? finance_configuration_profit_cost_center_ids.split(",")
          : [];
      this.finance_configuration_tag_ids =
        finance_configuration_tag_ids != "false"
          ? finance_configuration_tag_ids.split(",")
          : [];
      this.cost_types_ids =
        cost_types_ids != "false" ? cost_types_ids.split(",") : [];
      this.cost_appropriations_ids =
        cost_appropriations_ids != "false"
          ? cost_appropriations_ids.split(",")
          : [];
      this.filter_by_period = filter_by_period;
      this.start_date = start_date;
      this.end_date = end_date;

      let {
        user: { rest_home_name, rest_home_fantasy_name, logo_url },
      } = userData();

      this.user = userData().user;
      this.rest_home_name = rest_home_name;
      this.rest_home_fantasy_name = rest_home_fantasy_name;
      this.rest_home_logo_url = logo_url;

      try {
        this.loading = true;

        let {
          type,
          cash_competence,
          month,
          dayMonthYear,
          account_ids,
          types_of_entries_ids,
          users_ids,
          provider_ids,
          finance_client_ids,
          finance_configuration_document_types_ids,
          finance_configuration_payment_methods_ids,
          finance_configuration_category_ids,
          finance_configuration_profit_cost_center_ids,
          finance_configuration_tag_ids,
          cost_types_ids,
          cost_appropriations_ids,
          filter_by_period,
          start_date,
          end_date,
        } = this;

        let params = {
          type,
          cash_competence,
          month,
          dayMonthYear,
          account_ids,
          types_of_entries_ids,
          users_ids,
          provider_ids,
          finance_client_ids,
          finance_configuration_document_types_ids,
          finance_configuration_payment_methods_ids,
          finance_configuration_category_ids,
          finance_configuration_profit_cost_center_ids,
          finance_configuration_tag_ids,
          cost_types_ids,
          cost_appropriations_ids,
          filter_by_period,
          start_date,
          end_date,
          itemsPerPage: 5000,
        };

        let response = await api.get("/rest-home/financial/launch/list-print", {
          params,
        });

        let {
          error,
          errors,
          exist_data,
          data,
          balance_date,
          total_gain,
          total_spent,
          period_result,
        } = response.data;

        if (error) {
          this.errors = errors;
          this.data = [];
          this.exist_data = false;
        } else {
          this.exist_data = exist_data;
          this.data = data;
          this.balance_date = balance_date;
          this.total_gain = total_gain;
          this.total_spent = total_spent;
          this.period_result = period_result;
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    handlePrint() {
      window.print();
    },
  },
};
</script>

<style>
.print-launch-releases .header,
.print-launch-releases .header-space,
.print-launch-releases .footer,
.print-launch-releases .footer-space {
  height: 100px;
}

.print-launch-releases .header {
  position: fixed;
  top: 0;
}

.print-launch-releases .footer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.print-launch-releases table {
  width: 100% !important;
  cursor: auto !important;
}

.print-launch-releases .logo {
  height: 50px;
  object-fit: contain;
}
.print-launch-releases .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}
.print-launch-releases .resident_photo_url {
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
}

@media print {
  * {
    background: transparent !important;
    color: #000 !important;
    text-shadow: none !important;
    filter: none !important;
    -ms-filter: none !important;
  }

  .print-launch-releases table {
    page-break-before: always !important;
  }

  .print-launch-releases .footer {
    position: fixed;
    height: 100px !important;
    left: 0 !important;
    bottom: 0 !important;
    right: 0 !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .print-launch-releases .content {
    page-break-inside: avoid !important;
  }

  .print-launch-releases .page-break-before-always {
    page-break-before: always !important;
  }

  .print-launch-releases .page-break-inside-avoid {
    page-break-inside: avoid !important;
  }

  body {
    margin: 0 !important;
    padding: 0 !important;
  }

  .print-launch-releases .btn-print-launch-releases {
    display: none;
  }
}
</style>